import type { Root as MdastRoot } from "mdast";
import { newlineToBreak } from "mdast-util-newline-to-break";

/**
 * `remark-breaks`-equivalent transform (§6.5).
 *
 * v1 always applies `remarkBreaks`, turning single (soft) line endings into
 * `<br>`. `remark-breaks` is a thin wrapper around `mdast-util-newline-to-break`,
 * so reusing that same util guarantees byte-for-byte parity with v1 rather than
 * re-implementing the newline splitting.
 *
 * It runs on a `structuredClone` of the (React Query cached) tree and is pure /
 * idempotent — it never mutates `contentMdast` in place, so repeated renders
 * cannot accumulate duplicate `break` nodes (§6.5).
 */
export function applySoftBreaks(root: MdastRoot): MdastRoot {
  const clone: MdastRoot = structuredClone(root);
  newlineToBreak(clone);
  return clone;
}
